import React from 'react';
import Chart from './Chart';

function Products(){
    return (
        <>
			<Chart/>

        </>
    )
}

export default Products;